// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.createlocation', {
        url:'/createlocation',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/createlocation/createlocation.tpl.html',
            controller: 'SupportCaseCreateLocationController as vm'
        }},
        resolve: {
            locationTypes: locationTypeResolver,
            locationCategories: locationCategoryResolver
        }
    });
}

// @ngInject
function locationTypeResolver(SupportApiService) {
    return SupportApiService.getLocationTypes();
}
// @ngInject
function locationCategoryResolver(SupportApiService) {
    return SupportApiService.getLocationCategories();
}

// @ngInject
function SupportCaseCreateLocationController($state, $scope, locationTypes, locationCategories, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.isEditing = true;
    vm.locationTypes = locationTypes.results;
    vm.locationCategories = locationCategories.results;
    vm.location = {
        locationNumber: 0,
        locationName: '',
        organizationNumber: '',
        startDate: new Date(),
        locationTypeId: 0,
        locationCategoryId: 0,
        isActive: false
    };
    vm.selectedLocationType = {};
    vm.selectedLocationCategory = {};

    //Methods
    vm.isAllowedToSave = isAllowedToSave;
    vm.saveChange = saveChange;
    vm.resetForm = resetForm;

    activate();

    function activate() {
    }

    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmCreateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                vm.location.locationCategoryId = vm.selectedLocationCategory.id;
                vm.location.locationTypeId = vm.selectedLocationType.id;
                SupportApiService.createLocation(vm.location).then(function(response) {
                    ToasterService.showSuccess($translate.instant('support.locationCreated'), $translate.instant('support.supportCase'));
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function resetForm() {
        vm.location = {
            locationNumber: 0,
            locationName: '',
            organizationNumber: '',
            startDate: new Date(),
            locationTypeId: 0,
            locationCategoryId: 0,
            isActive: false
        };
    }

    function isAllowedToSave() {
        return vm.location &&
            vm.location.locationNumber && vm.location.locationNumber > 0 &&
            vm.location.locationName && vm.location.locationName.length > 0 &&
            vm.location.organizationNumber && vm.location.organizationNumber.length > 0 &&
            vm.selectedLocationCategory && vm.selectedLocationCategory.id > 0 &&
            vm.selectedLocationType && vm.selectedLocationType.id > 0;
    }
}

angular
    .module('supportcases.createlocation', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseCreateLocationController', SupportCaseCreateLocationController);
